import React from "react";
import "./SurveySelectNew.scss";

const InfoSelectSeven = ({ id, degree, setDegree, leftLabel, rightLabel }) => {
  return (
    <div className="survey-select-indiv">
      <div className="survey-select-inner">
        <ul className="list">
          <li className="list__item">
            <p className="radio-top">
              전혀
              <br />
              그렇지 않다
            </p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              id={`${id}-opt-1`}
              value={1}
              onChange={() => setDegree(1)}
              checked={degree === 1 ? true : false}
              required
            />
            <label htmlFor={`${id}-opt-1`} className="label"></label>
          </li>
          <li className="list__item">
            <p className="radio-top radio-top-ex">그렇지 않다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              value={2}
              onChange={() => setDegree(2)}
              id={`${id}-opt-2`}
              checked={degree === 2 ? true : false}
            />
            <label htmlFor={`${id}-opt-2`} className="label"></label>
          </li>
          <li className="list__item">
            <p className="radio-top radio-top-ex">모르겠다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              value={3}
              onChange={() => setDegree(3)}
              id={`${id}-opt-3`}
              checked={degree === 3 ? true : false}
            />
            <label htmlFor={`${id}-opt-3`} className="label"></label>
          </li>
          <li className="list__item">
            <p className="radio-top radio-top-ex">그렇다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              value={4}
              onChange={() => setDegree(4)}
              id={`${id}-opt-4`}
              checked={degree === 4 ? true : false}
            />
            <label htmlFor={`${id}-opt-4`} className="label"></label>
          </li>
          <li className="list__item">
            <p className="radio-top radio-top-ex">매우 그렇다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              value={5}
              onChange={() => setDegree(5)}
              id={`${id}-opt-5`}
              checked={degree === 5 ? true : false}
            />
            <label htmlFor={`${id}-opt-5`} className="label"></label>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default InfoSelectSeven;
